import React, {useEffect, useState} from 'react';

import {Colors, Title, Loader, CtaButton} from '@optimaxdev/design-system';
import {useDispatch, useSelector} from 'react-redux';

import scroller from 'react-scroll/modules/mixins/scroller';

import {STEPS} from 'desktop/pages/checkout/constants/checkout';
import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {setIsEditingOneStepMethod} from 'desktop/pages/checkout/store/reducers/paymentStep/oneStep/oneStep';
import {changePaymentMethod} from 'desktop/pages/checkout/store/reducers/paymentStep/paymentMethods/paymentMethods';
import {getPaymentMethodSaveLoading} from 'desktop/pages/checkout/store/selectors/paymentStep/paymentMethodSave/paymentMethodSave';
import {
    getIsPaymentMethodsLoading,
    getNameSelectedMethod,
} from 'desktop/pages/checkout/store/selectors/paymentStep/paymentStep';

import {StepWrapper} from '../../../stepWrapper/stepWrapper';

import {useFilteredPrimerMethods} from './useFilteredPrimerMethods';

import s from './paymentMethodEdit.scss';

/**
 * One step payment method edit
 */
export const PaymentMethodEdit: React.FC = () => {
    const isPaymentLoading = useSelector(getIsPaymentMethodsLoading);
    const isLoading = useSelector(getPaymentMethodSaveLoading);
    const initialPaymentMethod = useSelector(getNameSelectedMethod);
    const dispatch = useDispatch();

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');

    const filteredMethods = useFilteredPrimerMethods({
        selectedPaymentMethod,
        setSelectedPaymentMethod,
    });

    const handleCancelEditPayment = () => {
        dispatch(setIsEditingOneStepMethod(false));
        scroller.scrollTo('payment-title-one-step', {
            duration: 1000,
            isDynamic: true,
            offset: 600,
            smooth: true,
        });
    };

    const handleChangePaymentMethod = () => {
        dispatch(changePaymentMethod(selectedPaymentMethod as PAYMENTS));
        handleCancelEditPayment();
    };

    useEffect(() => {
        if (initialPaymentMethod) {
            setSelectedPaymentMethod(initialPaymentMethod);
        }
    }, [initialPaymentMethod, setSelectedPaymentMethod]);

    return (
        <StepWrapper step={STEPS.PAYMENT_STEP}>
            <div className={s.oneStepTitle}>
                <Title color={Colors.blueCharcoal} level={2} lineHeight="40px">
                    Payment
                </Title>
            </div>

            <div aria-label="Payments methods list" className={s.wrapper}>
                {isPaymentLoading && (
                    <div className={s.loaderWrap}>
                        <Loader className={s.loader} />
                    </div>
                )}
                {filteredMethods.map(method => method)}
            </div>

            <div className={s.buttons}>
                <div className={s.button}>
                    <CtaButton onClick={handleCancelEditPayment} size="large" variant="ghost">
                        Cancel
                    </CtaButton>
                </div>
                <div className={s.button}>
                    <CtaButton
                        isLoading={isLoading}
                        onClick={handleChangePaymentMethod}
                        size="large"
                        type="button"
                    >
                        Confirm
                    </CtaButton>
                </div>
            </div>
        </StepWrapper>
    );
};
